import { FC } from 'react';
import { Box, Typography, Input, Grid } from '@oresundsbron/bridge-ui';
import Image from 'next/image';
import { useForm } from '@oresundsbron/use-form';
import { useTranslation } from 'next-i18next';
import { ThirdPartySignup } from './types';

interface NewsSubscriptionProps {
  namespace: string;
  disabled: boolean;
}

const NewsSubscription: FC<NewsSubscriptionProps> = ({
  namespace,
  disabled,
}) => {
  const { t } = useTranslation(['privateSignUp', 'common'], {
    nsMode: 'fallback',
  });

  const { registerField, getError } = useForm<ThirdPartySignup>({
    namespace,
  });

  return (
    <Box className="mt-8">
      <Typography as="h3" intent="headline" size="sm" gutter>
        {t('form.sections.newsSubscription.title')}
      </Typography>
      <Grid className="mb-4 gap-4">
        <Box className="relative col-span-full mt-2">
          <Image
            src="/images/club.jpg"
            sizes="100vw"
            width={343}
            height={352}
            style={{
              width: '100%',
              height: 'auto',
              maxHeight: 352,
              aspectRatio: '16/9',
              objectFit: 'cover',
            }}
            alt="Club Oresund"
          />
        </Box>
        <Typography className="col-span-full mt-2 max-w-[45ch]">
          {t('form.sections.newsSubscription.description')}
        </Typography>
        <Input
          {...registerField('subscribeToClub.subscribe', {
            type: 'checkbox',
            value: 'true',
          })}
          className="col-span-full mt-2"
          label={t('form.labels.newsSubscription')}
          error={getError('subscribeToClub.subscribe')}
          disabled={disabled}
        />
        <Typography intent="label" size="sm" className="col-span-full">
          {t('form.sections.newsSubscription.helpText')}
        </Typography>
      </Grid>
    </Box>
  );
};

export default NewsSubscription;
